var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infoBox"},[(_vm.panoramaTour)?_c('h3',{staticClass:"tourText"},[_vm._v(_vm._s(_vm.panoramaTour.getName()))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }